// this is an autogenerated file from App/Account/Content/Tasks/New/Content/Board/Content/Main/Subscribers/mutation-remove-subscribers.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks_New_Content_Board_Content_Main_Subscribers($board_id: uuid!, $user_ids: [uuid!]!) {
  delete_tasks_subscribers(
    where: {
      _and: [{ board_id: { _eq: $board_id } }, { user_id: { _in: $user_ids } }]
    }
  ) {
    returning {
      id
    }
  }
}

`